import m from "../../geodata/es2015/newZealandHigh";
window.am4geodata_newZealandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/newZealandHigh.js
// module id = null
// module chunks = 